<template>
  <button
    v-if="visible"
    class="button button-secondary mt-4 ml-auto mr-3"
    :class="{ 'button-disabled': disabled, 'button-secondary': !disabled }"
    @click="handleClick"
  >
    Responder
  </button>
</template>

<script>
export default {
  props: ["disabled", "visible"],
  methods: {
    handleClick() {
      if (this.disabled) {
        return;
      }
      this.$emit("clickedButton");
    }
  }
};
</script>
<style lang="scss" scoped></style>
